// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YbTd","footer":"styles_footer__2oWCb","passCodeTooltip":"styles_passCodeTooltip__1AYKp"};